import { Box } from '@factorialco/deprecated-design-system'
import type moment from 'moment'

import { observer } from 'mobx-react'

import { type ContractVersions } from 'modules/contracts/store/collections/contractVersions'
import { useShiftsToDisplay } from 'modules/shift_management/hooks/useShiftsToDisplay'
import type { EmployeeWithShifts, Shift, ShiftsRow } from 'modules/shift_management/lib/types'

import BaseShift from './BaseShift'

interface Props {
  shifts: Shift[]
  shiftsRow: ShiftsRow
  employee: EmployeeWithShifts
  date: moment.Moment
  contractVersions: ContractVersions
}

const ShiftCell = ({ shifts, shiftsRow, employee, date, contractVersions }: Props) => {
  const { shiftsToDisplay, previewPlannedBreaks } = useShiftsToDisplay({
    shifts,
    shiftsRow,
    date,
  })

  if (!shiftsToDisplay.length) return <></>

  return (
    <Box gap="s4">
      {shiftsToDisplay.map((shift, index) => (
        <BaseShift
          date={date}
          shiftsRow={shiftsRow}
          shift={shift}
          employee={employee}
          key={`BaseShiftCell-${shift.id || index}`}
          isNightShift={false}
          preview={shift.preview}
          previewPlannedBreaks={shift.preview ? previewPlannedBreaks : undefined}
          contractVersions={contractVersions}
        />
      ))}
    </Box>
  )
}

export default observer(ShiftCell)
